export default class Employees {
    constructor() {
        this.initReadMore();
    }

    initReadMore() {
        if (document.querySelector('.employees')) {
            const text = document.querySelectorAll('.employees .text');

            text.forEach((el) => {
                const height = el.offsetHeight;
                const readmore = document.querySelector('[data-id="' + el.dataset.id +'"].read-more');

                // Set height of description
                el.style.height = '125px';

                readmore.addEventListener('click', function(ev) {
                    ev.preventDefault();

                    el.style.height = height + 'px';

                    readmore.style.display = 'none';
                });
            });
        }
    }
}
